package kz.dentalcrm.app.screens.appointments.edit

import androidx.compose.animation.animateContentSize
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.graphics.drawscope.scale
import androidx.compose.ui.graphics.drawscope.translate
import androidx.compose.ui.graphics.vector.PathParser
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import compose.icons.FeatherIcons
import compose.icons.feathericons.Calendar
import compose.icons.feathericons.ChevronLeft
import compose.icons.feathericons.Plus
import compose.icons.feathericons.User
import dentalcrm.composeapp.generated.resources.delete
import compose.icons.feathericons.X
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.add_patient
import dentalcrm.composeapp.generated.resources.add_title_optional
import dentalcrm.composeapp.generated.resources.choose_date_of_appointment
import dentalcrm.composeapp.generated.resources.edit_appointment_title
import dentalcrm.composeapp.generated.resources.find_patient
import dentalcrm.composeapp.generated.resources.pick_doctor
import dentalcrm.composeapp.generated.resources.pick_patient
import dentalcrm.composeapp.generated.resources.save
import dentalcrm.composeapp.generated.resources.edit_button
import dentalcrm.composeapp.generated.resources.initial_inspection_header
import dentalcrm.composeapp.generated.resources.inspection_date_label
import dentalcrm.composeapp.generated.resources.no_inspection
import dentalcrm.composeapp.generated.resources.tab_appointment
import dentalcrm.composeapp.generated.resources.tab_services
import dentalcrm.composeapp.generated.resources.tab_treatment
import dentalcrm.composeapp.generated.resources.title
import dentalcrm.composeapp.generated.resources.treatment_list_header
import dentalcrm.composeapp.generated.resources.teeth_label
import dentalcrm.composeapp.generated.resources.add_service_label
import dentalcrm.composeapp.generated.resources.appointment_date
import dentalcrm.composeapp.generated.resources.selected_services_label
import dentalcrm.composeapp.generated.resources.quantity_label
import dentalcrm.composeapp.generated.resources.discount_label
import dentalcrm.composeapp.generated.resources.price_label
import dentalcrm.composeapp.generated.resources.total_label
import dentalcrm.composeapp.generated.resources.no_services_selected
import dentalcrm.composeapp.generated.resources.or_separator
import kotlinx.collections.immutable.persistentListOf
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.ui.UiStateScaffold
import kz.dentalcrm.app.core.ui.components.ContentButton
import kz.dentalcrm.app.core.ui.components.SegmentText
import kz.dentalcrm.app.core.ui.components.SegmentedControl
import kz.dentalcrm.app.core.ui.components.UIButton
import kz.dentalcrm.app.core.ui.components.UISelfTextInput
import kz.dentalcrm.app.core.ui.components.UISelfDropDownTextInput
import kz.dentalcrm.app.core.ui.components.UITextInputClickable
import kz.dentalcrm.app.core.ui.components.tooth.TeethPaths
import kz.dentalcrm.app.core.ui.components.tooth.ToothSelector
import kz.dentalcrm.app.core.utils.formatToInspectionDate
import kz.dentalcrm.app.data.network.response_model.PatientTreatment
import kz.dentalcrm.app.core.utils.getMonthsShort
import kz.dentalcrm.app.expectations.rememberContactPickerState
import kz.dentalcrm.app.navigation.AddPatientTreatmentRoute
import kz.dentalcrm.app.navigation.AppNavigator
import kz.dentalcrm.app.navigation.InitialInspectionRoute
import kz.dentalcrm.app.navigation.PatientDetailRoute
import kz.dentalcrm.app.screens.appointments.add.HeaderStep
import kz.dentalcrm.app.screens.patients.PatientItem
import kz.dentalcrm.app.screens.patients.add.AddPatientDialog
import kz.dentalcrm.app.screens.ui.ContentHeader
import kz.dentalcrm.app.theme.DefaultTheme
import kz.dentalcrm.app.core.ui.components.AppointmentDateTimeDialog
import kz.dentalcrm.app.core.ui.components.UIIconBackButton
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun EditAppointmentScreen(
    appointmentId: Int,
) {
    val viewModel: EditAppointmentViewModel = koinViewModel()
    val state by viewModel.viewState.collectAsState()
    val event: (EditAppointmentEvent) -> Unit = viewModel::setEvent

    val navigator: AppNavigator = koinInject()

    LaunchedEffect(Unit) {
        viewModel.setEvent(EditAppointmentEvent.LoadData(appointmentId))
    }

    LaunchedEffect("Screen_start") {
        viewModel.effect.collect { effect ->
            when (effect) {
                is EditAppointmentEffect.NavigateBack -> { navigator.navigateUp() }
                is EditAppointmentEffect.ShowError -> {
                    // Handle error
                }
            }
        }
    }

    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        var addPatientDialog by remember { mutableStateOf(false) }
        if (addPatientDialog) {
            AddPatientDialog(
                onAdd = { patient ->
                    patient?.let {
                        event.invoke(EditAppointmentEvent.SelectPatient(patient))
                    }
                    addPatientDialog = false
                },
                onDismiss = {
                    addPatientDialog = false
                }
            )
        }

        val contactPicker = rememberContactPickerState {}
        val contactSelected by contactPicker.value

        LaunchedEffect(contactSelected) {
            contactSelected?.phoneNumbers?.first().orEmpty().takeIf { it.isNotEmpty() }?.let {
                event(EditAppointmentEvent.SearchPatient(it))
            }
        }

        var dateTimeSelect by remember { mutableStateOf(false) }

        if (dateTimeSelect) {
            AppointmentDateTimeDialog(
                startDateTime = state.selectDateTime,
                onDismissRequest = { dateTimeSelect = false },
                onDateSelected = { dateTime ->
                    event.invoke(EditAppointmentEvent.SelectDateTime(dateTime))
                    dateTimeSelect = false
                }
            )
        }

        UiStateScaffold(
            modifier = Modifier.fillMaxSize(),
            isLoading = state.isLoading
        ) {
            Column(
                modifier = Modifier.fillMaxSize()
                    .statusBarsPadding()
            ) {
                ContentHeader(
                    modifier = Modifier.fillMaxWidth()
                        .padding(horizontal = 12.dp),
                    text = stringResource(Res.string.edit_appointment_title),
                    leadingContent = {
                        UIIconBackButton(
                            onClick = {
                                navigator.navigateUp()
                            }
                        )
                    }
                )

                val tabs = persistentListOf(
                    stringResource(Res.string.tab_appointment),
                    stringResource(Res.string.tab_treatment),
                    stringResource(Res.string.tab_services)
                )

                val pagerState = rememberPagerState(
                    initialPage = state.selectedTabIndex,
                    pageCount = { tabs.size }
                )
                val coroutineScope = rememberCoroutineScope()

                // Sync pager with state when tab changes from ViewModel
                LaunchedEffect(state.selectedTabIndex) {
                    if (pagerState.currentPage != state.selectedTabIndex) {
                        pagerState.animateScrollToPage(state.selectedTabIndex)
                    }
                }

                SegmentedControl(
                    segments = tabs,
                    selectedSegment = tabs[state.selectedTabIndex],
                    onSegmentSelected = { tab ->
                        val index = tabs.indexOf(tab)
                        event(EditAppointmentEvent.SelectTab(index))
                        coroutineScope.launch {
                            pagerState.animateScrollToPage(index)
                        }
                    },
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp, vertical = 8.dp)
                        .background(
                            color = DefaultTheme.colors.surfaceAlternative,
                            shape = RoundedCornerShape(12.dp)
                        )
                ) { segment, isSelected ->
                    SegmentText(
                        text = segment,
                        isSelected = isSelected
                    )
                }

                HorizontalPager(
                    state = pagerState,
                    userScrollEnabled = false,
                    modifier = Modifier.weight(1f)
                ) { page ->
                    when (page) {
                        0 -> AppointmentTabContent(
                            state = state,
                            event = event,
                            onAddPatientClick = { addPatientDialog = true },
                            onDateTimeClick = { dateTimeSelect = true },
                            onContactPick = { contactPicker.launchContactPicker() },
                            onPatientClick = { patientId ->
                                navigator.navigate(PatientDetailRoute(patientId))
                            }
                        )
                        1 -> TreatmentTabContent(
                            state = state,
                            event = event,
                            navigator = navigator,
                            onAddTreatmentClick = {
                                navigator.navigate(
                                    AddPatientTreatmentRoute(
                                        appointmentId = appointmentId,
                                        //initialTeeth = state.treatmentState.selectedTeeth
                                    )
                                )
                            }
                        )
                        2 -> ServicesTabContent(
                            state = state,
                            event = event
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun AppointmentTabContent(
    state: EditAppointmentState,
    event: (EditAppointmentEvent) -> Unit,
    onAddPatientClick: () -> Unit,
    onDateTimeClick: () -> Unit,
    onContactPick: () -> Unit,
    onPatientClick: (Int) -> Unit
) {
    if (!state.isInitialLoadComplete) {
        return
    }

    LazyColumn(
        modifier = Modifier.fillMaxSize()
            .padding(horizontal = 16.dp)
            .animateContentSize()
    ) {
        item(key = "patient_step") {
            Column(
                modifier = Modifier.animateItem()
            ) {
                Spacer(modifier = Modifier.height(24.dp))
                HeaderStep(
                    title = stringResource(Res.string.pick_patient),
                    position = 1
                )
                Spacer(modifier = Modifier.height(4.dp))
            }
        }

        state.selectedPatient?.let { patient ->
            item("selected_patient") {
                Row(
                    modifier = Modifier.animateItem(),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    PatientItem(
                        modifier = Modifier.weight(1f),
                        item = patient
                    ) {
                        onPatientClick(patient.id)
                    }
                    Spacer(
                        modifier = Modifier.width(8.dp)
                    )
                    ContentButton(
                        modifier = Modifier.size(56.dp),
                        shape = RoundedCornerShape(16.dp),
                        onClick = {
                            event.invoke(EditAppointmentEvent.RemovePatient)
                        }
                    ) {
                        Box(
                            modifier = Modifier.fillMaxSize()
                                .background(
                                    color = DefaultTheme.colors.error,
                                    shape = RoundedCornerShape(16.dp)
                                ),
                            contentAlignment = Alignment.Center
                        ) {
                            Icon(
                                imageVector = FeatherIcons.X,
                                contentDescription = null,
                                tint = DefaultTheme.colors.onPrimary,
                                modifier = Modifier.size(24.dp)
                            )
                        }
                    }
                }
                Spacer(modifier = Modifier.height(8.dp))
            }
        }

        if (state.selectedPatient == null) {
            item(key = "patient_search") {
                Column(
                    modifier = Modifier.animateItem()
                ) {
                    UISelfTextInput(
                        modifier = Modifier.fillMaxWidth(),
                        label = stringResource(Res.string.find_patient),
                        value = state.searchPatientInput.value,
                        keyboardOptions = KeyboardOptions(imeAction = ImeAction.Done).copy(
                            keyboardType = KeyboardType.Text
                        ),
                        trailingIcon = FeatherIcons.User,
                        trailingActionClear = false,
                        trailingIconClicked = {
                            onContactPick()
                        },
                        valueChanged = {
                            event(EditAppointmentEvent.SearchPatient(it))
                        }
                    )
                    Spacer(modifier = Modifier.height(8.dp))
                }
            }

            items(items = state.suggestedPatients, key = { it.id }) {
                PatientItem(
                    modifier = Modifier.animateItem(),
                    item = it
                ) {
                    event.invoke(EditAppointmentEvent.SelectPatient(it))
                }
            }

            item(key = "patient_step_alter") {
                Column(
                    modifier = Modifier.animateItem()
                ) {
                    Text(
                        modifier = Modifier.fillMaxWidth(),
                        style = DefaultTheme.typography.labelRegular,
                        textAlign = TextAlign.Center,
                        color = DefaultTheme.colors.onSurfaceVariant,
                        text = stringResource(Res.string.or_separator)
                    )
                    Spacer(modifier = Modifier.height(8.dp))
                    UIButton(
                        text = stringResource(Res.string.add_patient),
                        onClick = {
                            onAddPatientClick()
                        }
                    )
                    Spacer(modifier = Modifier.height(8.dp))
                }
            }
        }
        item(key = "time_step") {
            Column(
                modifier = Modifier.animateItem()
            ) {
                Spacer(modifier = Modifier.height(16.dp))
                HeaderStep(
                    title = stringResource(Res.string.appointment_date),
                    position = 2
                )
                Spacer(modifier = Modifier.height(8.dp))
                UITextInputClickable(
                    modifier = Modifier.fillMaxWidth(),
                    label = stringResource(Res.string.choose_date_of_appointment),
                    defaultValue = state.dateFormatted ?: "",
                    valueChanged = { },
                    onClicked = {
                        onDateTimeClick()
                    }
                )
                Spacer(modifier = Modifier.height(8.dp))
            }
        }
        item(key = "appointment_step") {
            Column(
                modifier = Modifier.animateItem()
            ) {
                Spacer(modifier = Modifier.height(16.dp))
                HeaderStep(
                    title = stringResource(Res.string.pick_doctor),
                    position = 3
                )
                FlowRow(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                    verticalArrangement = Arrangement.spacedBy(8.dp),
                    maxItemsInEachRow = 2,
                ) {
                    state.employees.forEach {
                        Box(
                            modifier = Modifier
                                .clip(
                                    shape = RoundedCornerShape(16.dp)
                                )
                                .background(
                                    color = if (it.selected) {
                                        DefaultTheme.colors.primary
                                    } else {
                                        DefaultTheme.colors.surfaceAlternative
                                    },
                                    shape = RoundedCornerShape(16.dp)
                                ).padding(horizontal = 16.dp, vertical = 8.dp)
                                .clickable {
                                    event.invoke(
                                        EditAppointmentEvent.SelectEmployee(
                                            it.data
                                        )
                                    )
                                }
                        ) {
                            Text(
                                text = "${it.data.surname} ${it.data.name?.firstOrNull()}.${
                                    if (it.data.patronymic.isNullOrEmpty()) {
                                        ""
                                    } else {
                                        "${it.data.patronymic.firstOrNull()}."
                                    }
                                }",
                                style = DefaultTheme.typography.bodyMediumMedium,
                                color =
                                    if (it.selected) {
                                        DefaultTheme.colors.onPrimary
                                    } else {
                                        DefaultTheme.colors.onSurface
                                    }
                            )
                        }
                    }
                }
            }
        }
        item(key = "title_step") {
            Column(
                modifier = Modifier.animateItem()
            ) {
                Spacer(modifier = Modifier.height(16.dp))
                HeaderStep(
                    title = stringResource(Res.string.add_title_optional),
                    position = 4
                )
                UISelfTextInput(
                    modifier = Modifier.fillMaxWidth(),
                    label = stringResource(Res.string.title),
                    value = state.commentInput.value,
                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Done).copy(
                        keyboardType = KeyboardType.Text
                    ),
                    valueChanged = {
                        event.invoke(EditAppointmentEvent.CommentChanged(it))
                    }
                )
            }
        }
        item("confirm") {
            Spacer(modifier = Modifier.height(24.dp))
            UIButton(
                text = stringResource(Res.string.save),
                isLoading = state.isSaving,
                enabled = state.enableSave,
                onClick = {
                    event.invoke(EditAppointmentEvent.Save)
                }
            )
        }
        item("footer") {
            Box(
                modifier = Modifier.height(56.dp)
                    .navigationBarsPadding()
            )
        }
    }
}

@Composable
private fun TreatmentTabContent(
    state: EditAppointmentState,
    event: (EditAppointmentEvent) -> Unit,
    navigator: AppNavigator,
    onAddTreatmentClick: () -> Unit
) {
    val monthsShort = getMonthsShort()
    val scrollState = rememberScrollState()

    Box(
        modifier = Modifier.fillMaxSize()
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .verticalScroll(scrollState)
                .padding(horizontal = 16.dp)
        ) {
            Spacer(modifier = Modifier.height(16.dp))
            ToothSelector(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(350.dp)
                    .clickable(
                        indication = null,
                        interactionSource = remember { MutableInteractionSource() }
                    ) {
                        navigator.navigate(
                            AddPatientTreatmentRoute(
                                appointmentId = state.appointmentId,
                            )
                        )
                    },
                selectedTeeth = state.treatmentState.selectedTeeth,
                onToothClick = { toothId ->
                    navigator.navigate(
                        AddPatientTreatmentRoute(
                            appointmentId = state.appointmentId,
                        )
                    )
                    //event(EditAppointmentEvent.ToggleTooth(toothId))
                },
                showPrimary = true,
                showPermanent = true,
                selectedColor = DefaultTheme.colors.primary.copy(alpha = 1f),
                unselectedColor = DefaultTheme.colors.surfaceAlternative.copy(alpha = 0.8f),
                strokeColor = DefaultTheme.colors.outline.copy(alpha = 0.6f),
                enabled = true
            )
            Spacer(modifier = Modifier.height(16.dp))

            state.initialInspection?.let { inspection ->
                val formattedDate = inspection.created_at?.formatToInspectionDate(monthsShort)

                ContentButton(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(16.dp),
                    onClick = {
                        navigator.navigate(InitialInspectionRoute(state.appointmentId))
                    }
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(
                                color = DefaultTheme.colors.surfaceBackgroundSecondary,
                                shape = RoundedCornerShape(16.dp)
                            )
                            .padding(horizontal = 16.dp, vertical = 12.dp),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Column(
                            modifier = Modifier.weight(1f)
                        ) {
                            Text(
                                text = stringResource(Res.string.initial_inspection_header),
                                style = DefaultTheme.typography.bodyMediumMedium,
                                color = DefaultTheme.colors.onSurface
                            )
                            Spacer(modifier = Modifier.height(4.dp))
                            Row(
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Icon(
                                    imageVector = FeatherIcons.Calendar,
                                    contentDescription = null,
                                    tint = DefaultTheme.colors.onSurfaceVariant,
                                    modifier = Modifier.size(14.dp)
                                )
                                Spacer(modifier = Modifier.width(4.dp))
                                Text(
                                    text = "${stringResource(Res.string.inspection_date_label)} ${formattedDate ?: stringResource(Res.string.no_inspection)}",
                                    style = DefaultTheme.typography.bodySmallRegular,
                                    color = DefaultTheme.colors.onSurfaceVariant
                                )
                            }
                        }
                    }
                }
                Spacer(modifier = Modifier.height(16.dp))
            } ?: run {
                // No initial inspection
                ContentButton(
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(16.dp),
                    onClick = {
                        navigator.navigate(InitialInspectionRoute(state.appointmentId))
                    }
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(
                                color = DefaultTheme.colors.surfaceBackgroundSecondary,
                                shape = RoundedCornerShape(16.dp)
                            )
                            .padding(horizontal = 16.dp, vertical = 12.dp),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Column(
                            modifier = Modifier.weight(1f)
                        ) {
                            Text(
                                text = stringResource(Res.string.initial_inspection_header),
                                style = DefaultTheme.typography.bodyMediumMedium,
                                color = DefaultTheme.colors.onSurface
                            )
                            Spacer(modifier = Modifier.height(4.dp))
                            Text(
                                text = stringResource(Res.string.no_inspection),
                                style = DefaultTheme.typography.bodySmallRegular,
                                color = DefaultTheme.colors.onSurfaceVariant
                            )
                        }
                        Text(
                            text = stringResource(Res.string.edit_button),
                            style = DefaultTheme.typography.bodyMediumMedium,
                            color = DefaultTheme.colors.primary
                        )
                    }
                }
                Spacer(modifier = Modifier.height(16.dp))
            }

            // Treatment list section
            if (state.treatmentState.isLoadingTreatments) {
                Box(
                    modifier = Modifier.fillMaxWidth().padding(vertical = 16.dp),
                    contentAlignment = Alignment.Center
                ) {
                    CircularProgressIndicator(
                        modifier = Modifier.size(24.dp),
                        color = DefaultTheme.colors.primary
                    )
                }
            } else if (state.treatmentState.treatments.isNotEmpty()) {
                Text(
                    text = stringResource(Res.string.treatment_list_header),
                    style = DefaultTheme.typography.bodyMediumMedium,
                    color = DefaultTheme.colors.onSurface
                )
                Spacer(modifier = Modifier.height(12.dp))

                state.treatmentState.treatments.forEach { treatment ->
                    TreatmentItem(
                        treatment = treatment,
                        monthsShort = monthsShort,
                        onClick = { }
                    )
                }
            }

            Spacer(modifier = Modifier.height(80.dp))
        }

        FloatingActionButton(
            onClick = onAddTreatmentClick,
            modifier = Modifier
                .align(Alignment.BottomEnd)
                .padding(16.dp)
                .navigationBarsPadding(),
            containerColor = DefaultTheme.colors.primary,
            contentColor = DefaultTheme.colors.onPrimary
        ) {
            Icon(
                imageVector = FeatherIcons.Plus,
                contentDescription = null,
                modifier = Modifier.size(24.dp)
            )
        }
    }
}

@Composable
private fun ServicesTabContent(
    state: EditAppointmentState,
    event: (EditAppointmentEvent) -> Unit
) {
    val scrollState = rememberScrollState()

    // Load services when tab is shown
    LaunchedEffect(Unit) {
        event(EditAppointmentEvent.LoadServices)
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .verticalScroll(scrollState)
            .padding(horizontal = 16.dp)
    ) {
        Spacer(modifier = Modifier.height(16.dp))

        // Search dropdown
        UISelfDropDownTextInput(
            modifier = Modifier.fillMaxWidth(),
            label = stringResource(Res.string.add_service_label),
            items = state.servicesState.allServices,
            selectedItems = emptyList(), // Always empty - no selection highlighting
            multiSelect = false,
            clearOnSelect = true,
            itemToString = { service -> "${service.name ?: ""} - ${service.price ?: 0} \u20B8" },
            onItemsSelected = { selected ->
                selected.firstOrNull()?.let { service ->
                    event(EditAppointmentEvent.AddService(service))
                }
            }
        )

        Spacer(modifier = Modifier.height(24.dp))

        // Selected services header
        Text(
            text = stringResource(Res.string.selected_services_label),
            style = DefaultTheme.typography.bodyMediumMedium,
            color = DefaultTheme.colors.onSurface
        )
        Spacer(modifier = Modifier.height(12.dp))

        if (state.servicesState.selectedServices.isEmpty()) {
            Text(
                text = stringResource(Res.string.no_services_selected),
                style = DefaultTheme.typography.bodyMediumRegular,
                color = DefaultTheme.colors.onSurfaceVariant
            )
        } else {
            state.servicesState.selectedServices.forEach { selectedService ->
                ServiceCard(
                    selectedService = selectedService,
                    onQuantityChange = { quantity ->
                        event(EditAppointmentEvent.UpdateServiceQuantity(selectedService.uniqueId, quantity))
                    },
                    onDiscountChange = { discount ->
                        event(EditAppointmentEvent.UpdateServiceDiscount(selectedService.uniqueId, discount))
                    },
                    onPriceChange = { price ->
                        event(EditAppointmentEvent.UpdateServicePrice(selectedService.uniqueId, price))
                    },
                    onRemove = {
                        event(EditAppointmentEvent.RemoveService(selectedService.uniqueId))
                    }
                )
                Spacer(modifier = Modifier.height(12.dp))
            }
        }

        Spacer(modifier = Modifier.height(24.dp))

        UIButton(
            text = stringResource(Res.string.save),
            isLoading = state.isSaving,
            enabled = state.servicesState.selectedServices.isNotEmpty(),
            onClick = {
                event(EditAppointmentEvent.Save)
            }
        )

        Spacer(modifier = Modifier.height(80.dp))
    }
}

@Composable
private fun ServiceCard(
    selectedService: SelectedService,
    onQuantityChange: (Int) -> Unit,
    onDiscountChange: (Int) -> Unit,
    onPriceChange: (Int) -> Unit,
    onRemove: () -> Unit
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(
                DefaultTheme.colors.surfaceAlternative,
                RoundedCornerShape(16.dp)
            )
            .border(
                1.dp,
                DefaultTheme.colors.outline.copy(alpha = 0.2f),
                RoundedCornerShape(16.dp)
            )
            .padding(16.dp)
    ) {
        // Service name
        Text(
            text = selectedService.service.name ?: "",
            style = DefaultTheme.typography.bodyLargeMedium,
            color = DefaultTheme.colors.onSurface
        )
        Spacer(modifier = Modifier.height(16.dp))

        // Quantity
        UISelfTextInput(
            modifier = Modifier.fillMaxWidth(),
            label = stringResource(Res.string.quantity_label),
            value = selectedService.quantity.toString(),
            keyboardOptions = KeyboardOptions(
                keyboardType = KeyboardType.Number,
                imeAction = ImeAction.Next
            ),
            valueChanged = { value ->
                value.toIntOrNull()?.let { onQuantityChange(it) }
            }
        )
        Spacer(modifier = Modifier.height(12.dp))

        // Discount
        UISelfTextInput(
            modifier = Modifier.fillMaxWidth(),
            label = stringResource(Res.string.discount_label),
            value = selectedService.discount.toString(),
            keyboardOptions = KeyboardOptions(
                keyboardType = KeyboardType.Number,
                imeAction = ImeAction.Next
            ),
            valueChanged = { value ->
                value.toIntOrNull()?.let { onDiscountChange(it) }
            }
        )
        Spacer(modifier = Modifier.height(12.dp))

        // Price
        UISelfTextInput(
            modifier = Modifier.fillMaxWidth(),
            label = stringResource(Res.string.price_label),
            value = selectedService.price.toString(),
            keyboardOptions = KeyboardOptions(
                keyboardType = KeyboardType.Number,
                imeAction = ImeAction.Next
            ),
            valueChanged = { value ->
                value.toIntOrNull()?.let { onPriceChange(it) }
            }
        )
        Spacer(modifier = Modifier.height(12.dp))

        // Total
        UISelfTextInput(
            modifier = Modifier.fillMaxWidth(),
            label = stringResource(Res.string.total_label),
            value = "${selectedService.total}",
            enabled = false,
            valueChanged = { }
        )
        Spacer(modifier = Modifier.height(16.dp))

        // Delete button
        UIButton(
            modifier = Modifier.fillMaxWidth(),
            text = stringResource(Res.string.delete),
            containerColor = DefaultTheme.colors.error,
            onClick = onRemove
        )
    }
}

@Composable
private fun TreatmentItem(
    treatment: PatientTreatment,
    monthsShort: List<String>,
    onClick: () -> Unit,
) {
    val teethText = if (treatment.teeth.isNotEmpty()) {
        treatment.teeth.joinToString(", ")
    } else {
        ""
    }
    val diagnosisName = treatment.diagnosis?.name ?: ""
    val formattedDate = treatment.created_at?.formatToInspectionDate(monthsShort)

    ContentButton(
        modifier = Modifier,
        shape = RoundedCornerShape(16.dp),
        onClick = onClick
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .heightIn()
                .background(
                    color = DefaultTheme.colors.primarySubdued,
                    shape = RoundedCornerShape(16.dp)
                ),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Spacer(modifier = Modifier.width(16.dp))
            Column(
                modifier = Modifier.weight(1f)
            ) {
                Spacer(modifier = Modifier.height(12.dp))

                // Date
                if (formattedDate != null) {
                    Text(
                        text = formattedDate,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        color = DefaultTheme.colors.onSurfaceVariant,
                        style = DefaultTheme.typography.bodySmallRegular,
                    )
                    Spacer(modifier = Modifier.height(4.dp))
                }

                // Diagnosis
                Text(
                    text = diagnosisName,
                    overflow = TextOverflow.Ellipsis,
                    maxLines = 2,
                    color = DefaultTheme.colors.onSurface,
                    style = DefaultTheme.typography.bodyMediumMedium,
                )

                // Teeth section
                if (teethText.isNotEmpty()) {
                    Spacer(modifier = Modifier.height(8.dp))
                    Text(
                        text = "${stringResource(Res.string.teeth_label)} $teethText",
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        color = DefaultTheme.colors.onSurfaceVariant,
                        style = DefaultTheme.typography.bodySmallRegular,
                    )
                    Spacer(modifier = Modifier.height(4.dp))
                    // Tooth icons row
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(4.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        treatment.teeth.take(8).forEach { toothNumber ->
                            ToothIcon(
                                toothId = toothNumber.toString(),
                                modifier = Modifier.size(24.dp),
                                fillColor = DefaultTheme.colors.primary,
                                strokeColor = DefaultTheme.colors.outline
                            )
                        }
                        if (treatment.teeth.size > 8) {
                            Text(
                                text = "+${treatment.teeth.size - 8}",
                                style = DefaultTheme.typography.bodySmallRegular,
                                color = DefaultTheme.colors.onSurfaceVariant
                            )
                        }
                    }
                }

                Spacer(modifier = Modifier.height(12.dp))
            }
            Spacer(modifier = Modifier.width(16.dp))
        }
    }
    Spacer(Modifier.height(12.dp))
}

@Composable
private fun ToothIcon(
    toothId: String,
    modifier: Modifier = Modifier,
    fillColor: androidx.compose.ui.graphics.Color,
    strokeColor: androidx.compose.ui.graphics.Color
) {
    val pathData = TeethPaths.paths[toothId] ?: return

    val path = remember(toothId) {
        PathParser().parsePathString(pathData).toPath()
    }

    val bounds = remember(path) {
        path.getBounds()
    }

    Canvas(modifier = modifier) {
        val scaleX = size.width / bounds.width
        val scaleY = size.height / bounds.height
        val scaleFactor = minOf(scaleX, scaleY) * 0.9f

        val translateX = (size.width - bounds.width * scaleFactor) / 2f - bounds.left * scaleFactor
        val translateY = (size.height - bounds.height * scaleFactor) / 2f - bounds.top * scaleFactor

        translate(left = translateX, top = translateY) {
            scale(scaleFactor, pivot = Offset.Zero) {
                drawPath(
                    path = path,
                    color = fillColor
                )
                drawPath(
                    path = path,
                    color = strokeColor,
                    style = Stroke(width = 1f / scaleFactor)
                )
            }
        }
    }
}
